export const VERSION = process.env.REACT_APP_VERSION || "2";
